// extracted by mini-css-extract-plugin
export var newsletterModal = "NewsletterModal-module--newsletterModal--baf8f";